import { OneSecondInMillis } from '@racemap/utilities/consts/time';
import { useEffect, useRef } from 'react';

/**
 * Calls the given function in a interval. The time between two call is given with the delay.
 * The callback function have to be a Async function.
 * @param callback Function that should called
 * @param delay Time between two call in ms.
 */

export function useInterval(callback: () => Promise<void>, delay = OneSecondInMillis): void {
  const savedCallback = useRef<() => Promise<void> | null>(undefined);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    let isCancelled = false;
    // Function to be executed on each animation frame
    async function onFrame() {
      if (isCancelled) return;
      try {
        const callback = savedCallback.current;
        if (callback != null) {
          await callback();
        }
      } finally {
        timeoutId = setTimeout(onFrame, delay);
      }
    }

    // Start the frame
    onFrame();

    // Clean things up
    return () => {
      isCancelled = true;
      clearTimeout(timeoutId);
    };
  }, [delay]);
}
